import React, { FC, useEffect } from 'react';
import { PageStep, EVENT_RESERVATION_STEPS, EventReservationPageState } from './states/EventReservationPageState';
import { InputStep } from './InputStep';
import { ConfirmationStep } from './ConfirmationStep';
import { CompleteStep } from './CompleteStep';
import './eventReservationPage.module.scss';
import { observer, useLocalStore } from 'mobx-react';
import { ErrorStep } from '../common/ErrorStep';
import { StepPage, StepPageBody, StepPageHeader, StepPageMain, StepPageSide } from '../common/stepPage';
import { StepIndicator } from '../common/stepPage/StepIndicator';
import { GlobalLoader } from '../../../main/containers/common/GlobalLoader';
import { NotFoundPage } from '../common/NotFoundPage';
import { FloatingEventInfo } from './components/FloatingEventInfo';
import { useNavigation } from '../../../mainv3/components/hocs/withNavigation';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { useFooter } from '../../../mainv3/states/FooterState';
import { getEventFooterType, getEventNavigationType } from '../event/EventDetailsPage';
import { RouteComponentProps } from 'react-router-dom';

type StepProps = {
  pageState: EventReservationPageState;
};

const StepPane = ({ pageState }: StepProps) => {
  switch (pageState.currentStep) {
    case PageStep.INPUT:
      return <InputStep pageState={pageState} />;
    case PageStep.CONFIRMATION:
      return <ConfirmationStep pageState={pageState} />;
    case PageStep.COMPLETE:
      return <CompleteStep />;
    case PageStep.ERROR:
      return <ErrorStep errorMessage={pageState.errorMessage} />;
    default:
      throw new Error('Unsupported step : ' + pageState.currentStep);
  }
};

type Props = RouteComponentProps<{ eventId: string }>;

export const EventReservationPage: FC<Props> = observer(({ match }: Props) => {
  const eventId = Number(match?.params.eventId);
  const pageState = useLocalStore(() => new EventReservationPageState());
  const { event, loading, currentStep, reserverType, userEventReservationStatus } = pageState;
  useEffect(() => {
    pageState.init(eventId, GlobalStatesV3.currentUser);
  }, []);
  const service = event.map((e) => e.service).get();
  useNavigation(getEventNavigationType(service));
  useFooter(getEventFooterType(service));
  if (loading) {
    return <GlobalLoader />;
  }
  if (event.isNotFound()) {
    return <NotFoundPage entityType="イベント" />;
  }
  return (
    <StepPage id="event-reservation-page">
      <StepPageHeader>イベントを予約する</StepPageHeader>
      <StepPageBody>
        <StepPageMain>
          <StepIndicator
            currentStep={currentStep.valueOf()}
            steps={EVENT_RESERVATION_STEPS}
            error={currentStep === PageStep.ERROR}
          />
          <StepPane pageState={pageState} />
        </StepPageMain>
        <StepPageSide>
          {reserverType !== null &&
            userEventReservationStatus !== null &&
            [PageStep.ERROR, PageStep.COMPLETE].indexOf(currentStep) < 0 && (
              <FloatingEventInfo
                event={event.get()}
                reserverType={reserverType}
                userEventReservationStatus={userEventReservationStatus}
              />
            )}
        </StepPageSide>
      </StepPageBody>
    </StepPage>
  );
});
